/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import styled, { css } from 'styled-components'

import { PrimaryButton } from 'src/components/Button'
import FlexBox from 'src/components/Common/FlexBox'
import Faqs from 'src/components/Faq'
import Icon from 'src/components/Icon'
import { useThemeContext } from 'src/contexts/ThemeContext'
import { useModalV2Context } from 'src/features/modal-v2'
import { pxToEm, pxToVw } from 'src/functions/units'

export const FaqButton = () => {
  const { openModal } = useModalV2Context()
  const { colors } = useThemeContext()

  return (
    <StyledFaqButton
      size="small"
      outlined
      onClick={() => {
        return openModal(
          {
            content: (
              <StyledTipsArticle>
                <Faqs />
              </StyledTipsArticle>
            ),
            dialogTitle: 'Frequently Asked Questions'
          },
          'faqs'
        )
      }}
    >
      <FlexBox as="span" alignItems="center" columnGap={8}>
        <StyledFaqsIcon icon="faqs" size={18} color={colors.primary} />
        FAQ
      </FlexBox>
    </StyledFaqButton>
  )
}

const StyledFaqButton = styled(PrimaryButton)``

const StyledFaqsIcon = styled(Icon)`
  vertical-align: text-top;
  margin-right: ${pxToVw(5)};

  ${({ theme }) => css`
    ${theme.mediaQuery.mobile`
      margin-right: ${pxToVw(5, 720)};
    `}
  `}
`

const StyledTipsArticle = styled.article`
  p {
    font-size: ${({ theme }) => pxToVw(theme.units.fontSize.body1)};
    line-height: ${({ theme }) => pxToEm(28, theme.units.fontSize.body1)};
    color: ${({ theme }) => theme.colors.gray};
    margin-bottom: 1.5625vw;
    margin-top: 0;

    strong {
      font-weight: 500;
      color: inherit;
    }
  }

  a,
  a:visited {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  ${({ theme }) => css`
    ${theme.mediaQuery.mobile`
      > p {
        font-size: ${pxToVw(25, 720)};
      }
    `}
  `}
`
